import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import { postServerDataWithPath } from "../../../action/common_action";
import {
  axiosInstnace as Axios,
  calculateAmountAndTax,
  getAdminData,
} from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import useModel from "../common/useModel";
import ApproveModel from "../common/approveModel";
import RejectModel from "../common/rejectModel";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Dropdown from "react-dropdown";
import { toast, ToastContainer } from "react-toastify";

const Index = (props) => {
  const [campaigns, handleCampaignList] = useState([]);
  const { isShowing, toggle } = useModel();
  const { isRejectShowing, rejectToggle } = useModel();
  const [user_email, handleUserEmail] = useState("");
  const [createCoupon, handleCreateCoupon] = useState(false);
  const [currentRequest, handleCurrentRequest] = useState("");
  const [typeText, handleTypeText] = useState("Amount in Percentage");
  const [coupons, handleCoupons] = useState([]);
  const [skip, handleSkip] = useState(0);
  const [startDate, handleStartDate] = useState(null);
  const [classPercentage, handleClassPercentage] = useState("");
  const [frequency, handleFrequency] = useState("onetime");
  const [customer, handleCustomer] = useState("");
  const [advertisers, handleadvertisers] = useState([]);
  const [customerSpecific, handleCustomerSpecific] = useState(false);
  const [classAmount, handleClassAmount] = useState("none");
  const [amount, handleAmount] = useState(undefined);
  const [coupontype, handlecoupontype] = useState("");
  const [couponCode, handleCouponCode] = useState(null);
  const adminData = getAdminData()

  //vjvjj
  const [campaignstatustype, handleCampaignstatustype] = useState(undefined);
  const [rostatustype, handleRostatustype] = useState(undefined);

  const [razorpay, handleRazorpay] = useState(undefined);
  const searchRazorpay = useRef(undefined);

  const [station, handleStation] = useState(undefined);
  const [email, handleEmail] = useState(undefined);
  const [audio, handleAudio] = useState("");
  const [campaignId, handleCampaignId] = useState("");
  const [searchName, handleSearchName] = useState(undefined);
  //vj
  // const [searchStation, handleSearchStation] = useState(undefined);
  const [count, handleCount] = useState(0);
  const customerName = useRef(undefined);
  const userEmail = useRef(undefined);
  // const packagetype = useRef(undefined);

  useEffect(() => {
    
    getCampaignlist(0, undefined, undefined, "Pending", false);
  }, []);

    //Generate a coupon
    const createCouponAgainstrequest = async () => {
      if (
        amount === "" ||
        startDate === null ||
        (!frequency && !toast.isActive("1"))
      ) {
        toast.error("All Fields Are Mandatory", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
        return;
      } else if (amount === "0" && !toast.isActive("1")) {
        toast.error("amount must be greater than 0", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
        return;
      }
      if (amount === "" || amount === "0") {
        return;
      }
      let type = "";
      if (classPercentage.length === 0) {
        type = "percentage";
      } else {
        type = "Flat Rate";
      }
      if(customerSpecific && !customer){
        toast.error("Please provide a valid customer email", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
        return;
      }
    const params = {
        type,
        discount: Number(amount),
        validUntil: startDate.valueOf(),
        userEmail: adminData.email,
        frequency,
        customer,
      };
      try {
        const data = await Axios.post(endPoints.createCoupons, params);
        const result = data.data;
        
        if (result.statusCode === 200) {
          handleStartDate(null);
          handleAmount("");
          let coupon = result.data.data[0]
          let params = {
            couponCode: coupon.couponCode,
            couponValue: coupon.discount,
            generatedCouponType: coupon.type  ,
            expiryAt: coupon.validUntil,
            status: "Generated",
            id: currentRequest._id,  
          }
          let updaterequest = await Axios.post(endPoints.updateRequestCoupon, params)
          window.location.reload(true)
        } else {
          toast.error("something went wrong", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: false,
            hideProgressBar: true,
            toastId: "2",
          });
          return;
        }
      } catch (error) {
        console.log(error);
      }
    }
  useEffect(()=>{
    handleCustomerSpecific(currentRequest.customer=== "all"? false: true)
    handleCustomer(currentRequest.customer !== "all"?currentRequest.customer:"")
    handleAmount(currentRequest.propValue)
    handlecoupontype(currentRequest.coupontype === "Percentage"? 'percentage':'Flat Rate')
    if(currentRequest.coupontype !== "Percentage"){
      handleClassPercentage("none");
                            handleClassAmount("");
                            // handleAmount("");
                            // handlecoupontype("Flat Rate")
                            handleTypeText("Amount in Flat Rate");
    }else{
      handleClassAmount("none");
      handleClassPercentage("");
      // handleAmount("");
      // handlecoupontype('percentage')
      handleTypeText("Amount in Percentage");

    }
  }, [currentRequest])
  //Handle Amount value
  const handleValue = (e) => {
    let amount = e.target.value;
    if (
      classPercentage === "" &&
      Number(amount) <= 100 &&
      Number(amount) >= 0
    ) {
      handleAmount(amount);
    } else if (
      classAmount === "" &&
      Number(amount) >= 0 &&
      Number(amount) <= 20000
    ) {
      handleAmount(amount);
    } else if (classPercentage === "" && Number(amount) === NaN) {
      handleAmount("");
    } else if (
      (classAmount === "" && Number(amount) === NaN) ||
      amount === ""
    ) {
      handleAmount("");
    } else {
      handleAmount("");
    }
  };

  const handleChange = (date) => {
    handleStartDate(date);
  };

  //Fetching the campaign list
  const getCampaignlist = async (skip, name, id, status, reset) => {
    var paramsConstrct;
    paramsConstrct = {
      page: skip + 1,
      email: userEmail.current.value,
      customer: customerName.current.value,
    };
    handleSkip(skip);
    try {
      let coupons = await Axios.post(
        endPoints.getCouponsRequested,
        paramsConstrct  
      );
      handleCampaignList(coupons.data.data);
      handleCount(coupons.data.count)
    } catch (error) {
      console.log(error);
    }
  };

  const callSearch = () => {
    getCampaignlist(0, undefined, undefined, "Pending", false);
  };

  const clearSearch = () => {
    window.location.reload(true);
    // this.userEmail.current.value = "";

    //   const customerName = undefined;
    //   const userEmail = undefined;
    //   setStartDate(undefined);
    //   setEndDate(undefined);
    //   handleEmail(undefined);
    //   handleRazorpay(undefined);
    //   handleSearchName(undefined);
    //   handleStation(undefined)
    //   // handleCampaignList([]);
    //   handlePackagetype(undefined);
    //   handleCampaignstatustype(undefined);
    //   handleRostatustype(undefined);

    //   getCampaignlist(0, undefined, undefined, "Pending",true);
  };

  const options = ["one", "two", "three", "four"];

  //Return the table for campaign
  return (
    <div>
      <ApproveModel
        isShowing={isShowing}
        hide={toggle}
        user_email={user_email}
        //  user_name = {user_name}
        //  user_mobile = {user_mobile}

        campaignId={campaignId}
        station={station}
        getCampaignlist={getCampaignlist}
      />{" "}
      <RejectModel
        isRejectShowing={isRejectShowing}
        hide={rejectToggle}
        user_email={user_email}
        //vj
        //  user_name = {user_name}
        //  user_mobile = {user_mobile}

        campaignId={campaignId}
        station={station}
        getCampaignlist={getCampaignlist}
      />{" "}
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        {/* <div className="navbar-header dashboard-header clearfix">
          <div className="logo-dashboard">
            <a id="logo">
              <img className="logo-trans" src="/assets/images/new_logo.png" />
            </a>{" "}
            <span> Welcome: {adminInfo.email} </span>{" "}
            <span>
              Last Login @{" "}
              {moment(adminInfo.lastLogin).format("DD/MM/YYYY hh:mm A")}{" "}
            </span>{" "}
          </div>{" "}
          <div
            className="user-profile pull-right"
            tabIndex={0}
            onClick={() => {
              localStorage.removeItem("adminInfo");
              window.location.href = "/admin/login";
            }}
          >
            <a>
              <span>
                LOGOUT{" "}
                <span className="log_img">
                  <img src="/assets/images/ic_logout.png" />
                </span>{" "}
              </span>{" "}
            </a>{" "}
          </div>{" "}
        </div>{" "} */}
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>{" "}
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Coupon Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                  Coupon Requests{" "}
                </span>{" "}
              </div>
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div
                        className={
                          !searchName && campaigns.length === 0
                            ? "search_camp none search-container"
                            : "search_camp search_list search-container"
                        }
                      >
                        <input
                          type="text"
                          ref={customerName}
                          placeholder="Enter customer email"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div
                        className={
                          !email && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={userEmail}
                          placeholder="Trade Partner Email"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    <td>
                      <div className="print_btn">
                        <button type="button" onClick={callSearch}>
                          Search{" "}
                        </button>{" "}
                        <button type="reset" onClick={clearSearch}>
                          Clear{" "}
                        </button>{" "}
                      </div>{" "}
                    </td>{" "}
                  </tr>{" "}
                </tbody>{" "}
              </table>{" "}
            </form>{" "}
            <div
              className={
                campaigns.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>Coupon Request Date</th>
                    <th>Customer</th>
                    <th>Frequency</th>
                    <th>Coupon Type</th>
                    <th>Proposed Value</th>
                    <th>Request Expiry Date</th>
                    <th>Justification</th>
                    <th>Actions</th>
                    <th>Coupon Code</th>
                    <th>Generated Coupon Type</th>
                    <th>Coupon Value</th>
                    <th>Coupon Expiry Date</th>
                    <th>Coupon Request ID</th>
                    <th>Requested By</th>{" "}
                  </tr>
                </thead>{" "}
                <tbody>
                  {" "}
                  {campaigns.map((campaign, i) => (
                    <tr key={i}>
                      <td>{moment(campaign.date).format("DD MMM YYYY")}</td>
                      <td>{campaign.customer}</td>
                      <td>
                        {campaign.frequency == "multi"
                          ? "Multiple"
                          : "One Time"}
                      </td>
                      <td>{campaign.coupontype}</td>
                      <td>{campaign.propValue}</td>
                      <td>{moment(campaign.validUntil).format("DD MMM YYYY")}</td>
                      <td>{campaign.justification}</td>
                      <td>
                        {campaign.status === "Requested" && (
                          <a
                            onClick={(e) => {
                              handleCurrentRequest(campaign);
                              handleCreateCoupon(true);
                            }}
                          >
                            <span class="tooltip-reject fct-edit">
                              <img src="/assets/images/edit.png" />
                              <span>Edit</span>
                            </span>
                          </a>
                        )}
                      </td>
                      <td>{campaign.couponCode}</td>
                          <td>{campaign.generatedCouponType}</td>
                      <td>{campaign.couponValue}</td>
                      <td>{moment(campaign.expiryAt).format("DD MMM YYYY")}</td>
                      <td>{campaign._id}</td>
                      <td>{campaign.requestBy}</td>
                    </tr>
                  ))}{" "}
                </tbody>{" "}
              </table>{" "}
              <div className="paginationTable" />{" "}
              {(skip > 0 || count > 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}{" "}
            </div>{" "}
            {createCoupon && (
              <div className="create_coupon">
                <h3>Create Coupon for {currentRequest._id}</h3>
                <div className="coupon_type">
                  <div style={{ display: "inline-block" }}>
                    <span className="coupon_head">Coupon Type</span>
                    <div className="radio_coupon">
                      <p className="percentage_container">
                        <input
                          type="radio"
                          id="coupon1"
                          name="radio_coupon"
                          className="custm_radio"
                          checked={coupontype==="percentage"}
                          onClick={() => {
                            handleClassAmount("none");
                            handleClassPercentage("");
                            handleAmount("");
                            handlecoupontype('percentage')
                            handleTypeText("Amount in Percentage");
                          }}
                        />
                        <label for="coupon1">In Percentage</label>
                      </p>
                      <p>
                        <input
                          type="radio"
                          id="coupon2"
                          name="radio_coupon"
                          checked={coupontype==="Flat Rate"}
                          className="custm_radio"
                          onClick={() => {
                            handleClassPercentage("none");
                            handleClassAmount("");
                            handleAmount("");
                            handlecoupontype("Flat Rate")
                            handleTypeText("Amount in Flat Rate");
                          }}
                        />
                        <label for="coupon2">Flat Rate</label>
                      </p>
                    </div>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "100px" }}>
                    {" "}
                    <span className="coupon_head">Coupon Frequency</span>
                    <div className="radio_coupon">
                      <p className="percentage_container">
                        <input
                          type="radio"
                          id="onetime"
                          className="custm_radio"
                          checked={frequency === "onetime"}
                          onClick={(e) => {
                            handleFrequency(e.target.id);
                          }}
                        />
                        <label for="onetime">One Time</label>
                      </p>
                      <p>
                        <input
                          type="radio"
                          id="multi"
                          className="custm_radio"
                          checked={frequency === "multi"}
                          onClick={(e) => {
                            handleFrequency(e.target.id);
                          }}
                        />
                        <label for="multi">Multiple</label>
                      </p>
                    </div>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "100px" }}>
                    {" "}
                    <span className="coupon_head">Target Audience</span>
                    <div className="radio_coupon">
                      <p className="percentage_container">
                        <input
                          type="radio"
                          id="general"
                          className="custm_radio"
                          checked={!customerSpecific}
                          onClick={(e) => {
                            handleCustomerSpecific(false);
                          }}
                        />
                        <label for="general">General</label>
                      </p>
                      <p>
                        <input
                          type="radio"
                          id="customer"
                          className="custm_radio"
                          checked={customerSpecific}
                          onClick={(e) => {
                            handleCustomerSpecific(true);
                          }}
                        />
                        <label for="customer">Customer Specific</label>
                      </p>
                    </div>
                  </div>
                  {customerSpecific && (
                    <div
                      style={{ display: "inline-block", marginLeft: "100px" }}
                    >
                      {" "}
                      <span className="coupon_head">Customer</span>
                      <input
                        class="width200 inputBox"
                        onChange={(e) => {
                          handleCustomer(e.target.value);
                        }}
                        value={customer}
                      />
                    </div>
                  )}
                </div>
                <div className="amount_date">
                  <div className="amount_percent">
                    <span className="amount_date_head">{typeText}</span>
                    <span className={`coupon_rupee_sign ${classAmount}`}>
                      <img src="../../../assets/images/rupee-indian.svg" />
                    </span>
                    <input
                      type="text"
                      value={amount}
                      className="percent_input"
                      onChange={handleValue}
                      placeholder="Amount"
                    />
                    <span className={`percentage_sign ${classPercentage}`}>
                      <img src="../../../assets/images/percent.svg" />
                    </span>
                  </div>
                  <div className="expiry_date">
                    <span className="amount_date_head">Expiry Date</span>
                    <div className="date_container">
                      <DatePicker
                        selected={startDate}
                        onChange={handleChange.bind(this)}
                        minDate={new Date()}
                        placeholderText="Date"
                      />
                      <span className="cla_icon">
                        <img src="../../../assets/images/calendar.svg" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="generate_coupon">
                  <button onClick={createCouponAgainstrequest}>Generate Coupon</button>
                </div>
              </div>
            )}
            {campaigns.length === 0 ? <NoData /> : null}{" "}
          </section>{" "}
          <ToastContainer/>
        </div>{" "}
      </div>{" "}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./web/components/admin/manageCoupon/requestcoupon.js